import React from "react";
import styled from "styled-components";

const AboutSection = (props) => {
  const [isMobile, setIsMobile] = React.useState(true);
  const lang = props.lang;
  React.useEffect(() => {
    setIsMobile(
      typeof window !== "undefined" ? window.screen.width < 800 : true
    );
  }, []);

  return (
    <Wrapper id="about">
      <img
        src="/LLL.png"
        width="25"
        style={{ width: 25, objectFit: "cover" }}
      />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        {!isMobile && <img src="/AboutL.png" width="200" />}
      </div>
      <div
        style={{
          padding: 10,
          width: 400,
          minWidth: 250,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img src="/AboutTitle.png" width="200" style={{ margin: 70 }} />

        <div
          style={{
            fontWeight: 500,
            fontSize: 18,
            paddingLeft: 10,
            paddingRight: 10,
          }}
        >
          {lang === "tw"
            ? "HiNFT 協助您自建專屬 NFT 販售平台，並提供用戶以加密貨幣及法幣購買 NFT 的可能。以 NFT 販售作為行銷及業務的新起點，善用區塊鏈特性來放大您的事業能量。"
            : "HiNFT Help you building your own NFT purchasing SPA / store."}
        </div>

        <div
          style={{
            marginTop: 20,
            flex: 1,
            padding: 20,
            backgroundColor: "white",
            width: "100%",
            borderRadius: 25,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            boxShadow: "7px 30px 56px 0 #d9d9d9, inset 14px 97px 16px 0 #fff",
          }}
        >
          {[
            [
              "/logo-icon1.png",
              lang === "tw" ? "宣傳網站開發" : "Website",
              lang === "tw" ? "客製化一頁式網站" : "",
              lang === "tw"
                ? "提供品牌行銷及與用戶互動的便利介面"
                : "Customized SPA / Website building",
            ],
            [
              "/logo-icon1.png",
              lang === "tw" ? "預售白單分發" : "Whitelist",
              lang === "tw" ? "VIP用戶的保障" : "",
              lang === "tw"
                ? "可藉優先保留名單的方式加強行銷力度"
                : "VIP program by Whitelist",
            ],
            [
              "/logo-icon1.png",
              lang === "tw" ? "狐狸錢包購買" : "Metamask",
              lang === "tw" ? "開放一般大眾搶購" : "",
              lang === "tw"
                ? "限時搶購作為品牌吸納普羅用戶的渠道"
                : "Users buy NFT by Metamask",
            ],

            [
              "/logo-icon1.png",
              lang === "tw" ? "法幣購買機制" : "Fiat Currency",
              lang === "tw" ? "擴充影響力到 WEB2" : "",
              lang === "tw"
                ? "結合日常電商體驗以擴大接觸用戶圈"
                : "fiat currency support (specific area)",
            ],

            [
              "/logo-icon1.png",
              lang === "tw" ? "系統整合規劃" : "System Integration",
              lang === "tw" ? "對接既有內部系統" : "",
              lang === "tw"
                ? "將 NFT 及 Web3 作為原有系統的延伸"
                : "Enable Web3 function from original system",
            ],
            [
              "/logo-icon1.png",
              lang === "tw" ? "實體憑證發行" : "Physical",
              lang === "tw" ? "提供線下流動性" : "",
              lang === "tw"
                ? "以冷錢包載體讓 NFT 及代幣能線下流通"
                : "Encapsulate NFT to hardware form",
            ],
            [
              "/logo-icon1.png",
              lang === "tw" ? "智能合約撰寫" : "Smart Contract",
              lang === "tw" ? "客製化智能合約" : "",
              lang === "tw"
                ? "彈性客製智能合約按需調整內部邏輯"
                : "Customized contract logic",
            ],
          ].map((item) => {
            return (
              <div
                key={item[1]}
                style={{ display: "flex", flexDirection: "row", width: "80%" }}
              >
                <div
                  style={{
                    padding: 5,
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={item[0]} width="60" />
                </div>
                <div
                  style={{
                    padding: 5,
                    display: "flex",
                    flex: 3,
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <div style={{ fontSize: 18, alignSelf: "flex-start" }}>
                    {item[1]}
                  </div>
                  <div
                    style={{
                      width: "100%",
                      height: 2,
                      backgroundColor: "#4b4bff",
                      marginTop: 5,
                      marginBottom: 5,
                    }}
                  />
                  <div
                    style={{
                      fontSize: 14,
                      alignSelf: "flex-start",
                      color: "#4b4bff",
                    }}
                  >
                    {item[2]}
                  </div>
                  <div style={{ fontSize: 14, alignSelf: "flex-start" }}>
                    {item[3]}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        {!isMobile && <img src="/AboutR.png" width="200" />}
      </div>

      <img
        src="/RRR.png"
        width="25"
        style={{ width: 25, objectFit: "cover" }}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;

  flex-direction: row;

  justify-content: flex-start;

  background-color: #f9f9f9;

  margin-top: -20px;
  margin-bottom: -15px;
`;

export default AboutSection;
